import { useState } from "react";
import ScaleLoader from "react-spinners/ScaleLoader";

const override = {
  display: "block",
  margin: "0 auto",
  borderColor: "red",
};

function Spinner1() {
  let [loading, setLoading] = useState(true);
  let [color, setColor] = useState("#4BA856");

  return (
    <div className="sweet-loading">
      <ScaleLoader
        color={color}
        loading={loading}
        size={150}
      />
    </div>
  );
}

export default Spinner1;